import { Badge } from 'uikit';

import type React from 'react';
import type { CSSProperties } from 'react';
import { type ReactNode } from 'react';

import { TooltipWrapper } from '../TooltipWrapper';

interface IMultiselectInformer {
    value: string | ReactNode;
    message?: string;
    style?: CSSProperties;
    className?: string;
}

export const MultiselectInformer: React.FC<IMultiselectInformer> = (props) => {
    const { value, style, className, message } = props;

    return typeof value === 'string' ? (
        <TooltipWrapper message={message} style={style} toolTipClassName={className}>
            <Badge size="xs" status="system" label={value} />
        </TooltipWrapper>
    ) : (
        <div style={style}>{value}</div>
    );
};

MultiselectInformer.displayName = 'MultiselectInformer';
